export const MAX_INPUT_ROWS = 2;
export const MAX_LENGTH_MESSAGE = 4000;
export const MESSAGE_LENGTH_ERROR = `Максимальная длина сообщения — ${MAX_LENGTH_MESSAGE} символов`;
